module.exports = __webpack_public_path__ + "img/image.25b8087b.png";